module.exports = __webpack_public_path__ + "img/logo_mendels_brain.c2354a09.png";